import { all, call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'redux-first-history';

import api from '@api';
import { UserRoutePaths } from '@routes/routesPaths';
import { putError, putWarning } from '@utils/notificationUtils';

import { uiActions } from '../actions';
import { LoadersNames } from '../ui/ui.actions';
import { createUser, deleteUser, updateUser } from './user.actions';

export function* createUserSaga({ payload }: ReturnType<typeof createUser.started>) {
  yield put(uiActions.showLoader(LoadersNames.fetchingUser));
  try {
    // @ts-ignore
    const result = yield call(api.user.createUserMutation, payload);
    yield put(createUser.done({ params: payload, result }));
    yield put(push(UserRoutePaths.userRoot));
  } catch (err) {
    yield putError(err, 'app:msg_title_error', 'app:error_creating_user');
  }
  yield put(uiActions.hideLoader(LoadersNames.fetchingUser));
}

export function* updateUserSaga({ payload }: ReturnType<typeof updateUser.started>) {
  yield put(uiActions.showLoader(LoadersNames.fetchingUser));
  try {
    const result = yield call(api.user.updateUserMutation, payload);
    yield put(updateUser.done({ params: payload, result}));
    yield put(push(UserRoutePaths.userRoot));
  } catch (err) {
    yield putError(err, 'app:msg_title_error', 'app:error_updating_user');
  }
  yield put(uiActions.hideLoader(LoadersNames.fetchingUser));
}

export function* deleteUserSaga({ payload }: ReturnType<typeof deleteUser.started>) {
  yield put(uiActions.showLoader(LoadersNames.fetchingUser));
  try {
    const result = yield call(api.user.deleteUserMutation, payload);
    yield put(deleteUser.done({ params: payload, result }));
    yield put(push(UserRoutePaths.userRoot));
    yield putWarning('app:msg_title_deleted', 'app:msg_user_deleted');
  } catch (err) {
    yield putError(err, 'app:msg_title_error', 'app:error_deleting_user');
  }
  yield put(uiActions.hideLoader(LoadersNames.fetchingUser));
}

export function* watchUserSaga() {
  yield all([
    yield takeLatest(createUser.started, createUserSaga),
    yield takeLatest(updateUser.started, updateUserSaga),
    yield takeLatest(deleteUser.started, deleteUserSaga),
  ]);
}
